import React from 'react';
import { useCalendarTimeGrid } from '../hooks/useCalendarTimeGrid';

const CalendarTimeColumn = ({ className = '' }) => {
  const { timeSlots, hourHeight } = useCalendarTimeGrid();

  return (
    <div className={`calendar-time-column ${className}`}>
      <div className="calendar-time-column__header" />

      {timeSlots.map((slot) => (
        <div
          key={slot.time}
          className="calendar-time-column__label"
          style={{ height: hourHeight }}
        >
          {slot.time}
        </div>
      ))}
    </div>
  );
};

export default CalendarTimeColumn;
